export const GRADE_LEVELS = {
  'math-foundations-1': { label: '2nd grade', course: 'Math Foundations 1', sortKey: 2 },
  'math-foundations-2': { label: '3rd grade', course: 'Math Foundations 2', sortKey: 3 },
  'math-foundations-3': { label: '4th grade', course: 'Math Foundations 3', sortKey: 4 },
  'arithmetic-mastery': { label: '5th grade', course: 'Arithmetic Mastery', sortKey: 5 },
  'math-foundations-4': { label: '6th grade', course: 'Math Foundations 4', sortKey: 6 },
  'intro-pre-algebra': { label: '7th grade', course: 'Intro to Pre Algebra', sortKey: 7 },
  'pre-algebra': { label: '8th grade', course: 'Pre Algebra', sortKey: 8 },
  'algebra-1': { label: '9th grade', course: 'Algebra 1', sortKey: 9 },
  geometry: { label: '10th grade', course: 'Geometry', sortKey: 10 },
  'algebra-2': { label: '11th grade', course: 'Algebra 2', sortKey: 11 },
  'pre-calculus': { label: '12th grade', course: 'Pre Calculus', sortKey: 12 },
  calculus: { label: 'College', course: 'Calculus', sortKey: 13 },
};

export function getGradeLevel(subjectId) {
  return GRADE_LEVELS[subjectId] ?? null;
}

export function getGradeSortKey(subjectId) {
  return GRADE_LEVELS[subjectId]?.sortKey ?? 999;
}